module.exports = __webpack_public_path__ + "media/components/assets/icons/menu_sidebar-77606fd58634a8fce4dbc15d448bb5de.svg";